import { request } from './repository';


const attendanceChannelRepository = {
    getChannels() {
        return request.get('channels');
    }
}

export default attendanceChannelRepository;
